import type { VehicleFacetOption } from './vehicleFacetOptions';
import { VehicleFilterCheck } from './VehicleFilterCheck';

type VehicleMakeFilterProps = {
    options: VehicleFacetOption[];
    selected: string[];
    onToggle: (make: string) => void;
};

/** Makes as checkboxes, each with its live number of hits. */
export function VehicleMakeFilter({ options, selected, onToggle }: VehicleMakeFilterProps) {
    if (!options.length) return null;

    return (
        <fieldset className="vehicle-filter__group">
            <legend className="vehicle-filter__legend label-xs">Marke</legend>

            {options.map((option) => (
                <VehicleFilterCheck
                    key={option.value}
                    label={option.label}
                    count={option.count}
                    checked={selected.includes(option.value)}
                    onChange={() => onToggle(option.value)}
                />
            ))}
        </fieldset>
    );
}
